import React, { useState, useEffect, useCallback } from 'react';
import { Button, FormGroup, Input, Dialog, Icon } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';
import { CorpSelector } from '../qw/corpSelector';
import '../qw/index.less';

const AuthConfig = (props) => {
  const [addressBookSecret, setAddressBookSecret] = useState(''); // 通讯录secret
  const [externalContactSecret, setExternalContactSecret] = useState(''); // 客户联系secret
  const [chatContentSecret, setChatContentSecret] = useState(''); // 会话归档secret
  const [rsaPublicKey, setRsaPublicKey] = useState(''); // 会话存档的rsa公钥
  const [showSuccessModal, setShowSuccessModal] = useState(false); // 弹窗是否展示

  const [contactError, setContactError] = useState(false);
  const [chatError, setChatError] = useState(false);

  const [addrError, setAddrError] = useState(false);

  const hanldeContactChange = (e, value) => {
    setExternalContactSecret(value);
    setContactError(!value.length);
  };

  const hanldeChatChange = (e, value) => {
    setChatContentSecret(value);
    setChatError(!value.length);
  };

  const HelpBlockComponent = (props = {}) => {
    const { children, helpBlockClassName = '', helpBlockStyle = {} } = props;
    return (
      <span className={`help-block ${helpBlockClassName}`} style={helpBlockStyle}>
        {children}
      </span>
    );
  };

  const init = useCallback(() => {
    RPCFactory.qwSystemConfig.getSecret().done((data) => {
      const {
        externalContactSecretSetStatus,
        chatContentSecretSetStatus,
        addressBookSecretSetStatus,
      } = data;
      if (externalContactSecretSetStatus === 1) {
        setExternalContactSecret('********');
      }
      if (chatContentSecretSetStatus === 1) {
        setChatContentSecret('********');
      }
      if (addressBookSecretSetStatus === 1) {
        setAddressBookSecret('********');
      }
    });
  }, []);

  const wxChatSecret = () => {
    // 会话存档
    const param = {
      chatContentSecret,
      externalContactSecret,
    };

    RPCFactory.qwSystemConfig
      .setChatSecret(param)
      .done(() => {
        init();
        setShowSuccessModal(true);
      })
      .fail((code, msg) => {
        alert(msg);
      });
  };

  const wxWorkSecret = () => {
    // 基础配置提交
    const param = { addressBookSecret };
    RPCFactory.qwSystemConfig
      .setSecret(param)
      .done(() => {
        init();
        setShowSuccessModal(true);
      })
      .fail((code, msg) => {
        alert(msg);
      });
  };

  const handleAddrChange = (e, value) => {
    setAddressBookSecret(value);
    setAddrError(!value.length);
  };

  const handleBaseSubmit = () => {
    if (addressBookSecret.length < 1) {
      setAddrError(true);
      return;
    }
    wxWorkSecret();
  };

  const handleSubmit = () => {
    if (externalContactSecret.length < 1) {
      setContactError(true);
    }
    if (chatContentSecret.length < 1) {
      setChatError(true);
    }
    if (externalContactSecret.length < 1 || chatContentSecret.length < 1) {
      return
    }
    wxChatSecret();
  };

  const getRsaPublcKey = () => {
    RPCFactory.qwSystemConfig.getPublicKey().done((data) => {
      setRsaPublicKey(data.rsaPublicKey);
    }).fail((ret, msg) => window.alert(msg));
  };

  useEffect(init, [init]);

  return (
    <main className="main" id="authConfig">
      <CorpSelector {...props} />
      <div className="card padding-normal qw-config-item">
          <div className="card-title">基础权限配置</div>
          <div className="qw-config-title">
            <span>详细配置流程可查看指引按步骤操作</span>
            <a
              className="config-link"
              target="_blank"
              href="https://docs.qq.com/doc/DY09lcmlydE5adldL" rel="noreferrer"
            >
              配置指引
            </a>
          </div>
          <div className="qw-config__guide">
            <div className="qw-config__guide--body">
              <div className="qw-config__guide--item">
                <div className="qw-config__guide--wrapper">
                  <div className="qw-config__guide--icon qw-icon__qw"></div>
                  <div className="qw-config__guide--text">1.进入企微管理后台开启通讯录同步并复制Secret</div>
                </div>
              </div>
              <div className="qw-config__guide--item arrow-item">
                <div className="blue-arrow"></div>
              </div>
              <div className="qw-config__guide--item">
                <div className="qw-config__guide--wrapper">
                  <div className="qw-config__guide--icon qw-icon__logo"></div>
                  <div className="qw-config__guide--text">2.在线索平台粘贴该Secret</div>
                </div>
              </div>
            </div>
          </div>
          <div className="qw-config__config">
            <div className="qw-config__config--label">通讯录 Secret</div>
            <div className={`qw-config__config--content${addrError ? ' has-error' : ''}`}>
              <Input value={addressBookSecret}
                placeholder="请输入通讯录 Secret"
                onChange={handleAddrChange}
              />
            </div>
          </div>
          <div className="qw-config-footer">
            <Button displayType="primary"
              style={{ padding: '0 71px' }}
              onClick={handleBaseSubmit}
            >保存配置</Button>
          </div>
      </div>

      <div className="card padding-normal">
        <div className="card-title">会话存档配置</div>
        <span style={{ fontSize: '14px', fontWeight: '400', marginBottom: '18px' }}>
          <Icon style={{ marginRight: '5px' }} type="tips" />
          请先点击获取消息加密公钥并复制至企微管理后台-管理工具-会话内容存档-设置消息加密公钥后，再在企微管理后台-管理工具-会话内容存档-查看Secret并复制至下方会话存档Secret处并点击保存。
        </span>
        <div className="card-option" style={{ marginTop: '18px' }}>
          <div className="configs">
            <ul className="config-list">
              <li className="inquire-li" style={{ minHeight: '55px', height: 'auto' }}>
                <span className="inquire-tt">消息加密公钥</span>
                <div className="inquire-con">
                  <FormGroup
                    status={'normal'}
                    helpBlockClassName="helpblock-test"
                    HelpBlockComponent={HelpBlockComponent}
                  >
                    {!rsaPublicKey && (
                      <Button
                        style={{ width: '388px' }}
                        onClick={() => {
                          getRsaPublcKey();
                        }}
                      >
                        点击获取
                      </Button>
                    )}
                    {rsaPublicKey && <span style={{ whiteSpace: 'pre' }}>{rsaPublicKey}</span>}
                  </FormGroup>
                </div>
              </li>
              <li className="inquire-li">
                <span className="inquire-tt required">客户联系 Secret</span>
                <div className="inquire-con">
                  <FormGroup
                    status={contactError ? 'error' : 'normal'}
                    helpBlockClassName="helpblock-test"
                    HelpBlockComponent={HelpBlockComponent}
                  >
                    <Input
                      style={{ width: '388px' }}
                      value={externalContactSecret}
                      onChange={hanldeContactChange}
                      placeholder="请输入客户联系 Secret"
                    />
                  </FormGroup>
                </div>
              </li>
              <li className="inquire-li">
                <span className="inquire-tt required">会话存档 Secret</span>
                <div className="inquire-con">
                  <FormGroup
                    status={chatError ? 'error' : 'normal'}
                    helpBlockClassName="helpblock-test"
                    HelpBlockComponent={HelpBlockComponent}
                  >
                    <Input
                      style={{ width: '388px' }}
                      value={chatContentSecret}
                      onChange={hanldeChatChange}
                      placeholder="请输入会话存档Secret"
                    />
                  </FormGroup>
                </div>
              </li>
              <li className="inquire-li">
                <div className="inquire-tt">
                  <Button
                    style={{ width: '100px' }}
                    displayType="primary"
                    onClick={handleSubmit}
                  >
                    保存
                  </Button>
                </div>
                <div className="inquire-con"></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Dialog
        type="tip"
        iconType="success"
        time={2000}
        timeCallback={() => {
          setShowSuccessModal(false);
        }}
        show={showSuccessModal}
      >
        操作成功！
      </Dialog>
    </main>
  );
};

export default AuthConfig;
